import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Clock, CheckCircle2, Mail, FileText } from "lucide-react";
import NewQuoteForm from "./NewQuoteForm";

interface EmptyQuotesStateProps {
  isAdmin: boolean;
  bookingId: string;
  onQuoteUpdate?: () => void;
}
const EmptyQuotesState = ({
  isAdmin,
  bookingId,
  onQuoteUpdate
}: EmptyQuotesStateProps) => {
  return <div>
      {isAdmin ? (
        <Tabs defaultValue="new-quote" className="w-full">
          <div className="relative border-b border-border">
            <TabsList className="grid w-full grid-cols-1">
              <TabsTrigger value="new-quote" className="px-4 h-10">
                New Quote
              </TabsTrigger>
            </TabsList>
          </div>
          <TabsContent value="new-quote" className="mt-4">
            <NewQuoteForm bookingId={bookingId} onQuoteCreated={() => onQuoteUpdate?.()} />
          </TabsContent>
        </Tabs>
      ) : (
        <Card className="p-8 text-center mt-6">
          <div className="flex flex-col items-center space-y-6 max-w-lg mx-auto">
            {/* Icon */}
            <div className="relative">
              <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
                <Clock className="w-10 h-10 text-primary" />
              </div>
            </div>

            {/* Heading */}
            <div className="space-y-2">
              <h3 className="text-xl font-semibold text-foreground">
                Awaiting Quote
              </h3>
              <p className="text-sm text-muted-foreground">
                Your booking request has been received successfully
              </p>
            </div>

            {/* Process Steps */}
            <div className="w-full space-y-4 text-left">
              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-success/10 flex items-center justify-center mt-0.5">
                  <CheckCircle2 className="w-4 h-4 text-success" />
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-sm text-foreground mb-1">
                    Booking Received
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    Your parcel details have been submitted and are being reviewed
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mt-0.5">
                  <FileText className="w-4 h-4 text-primary" />
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-sm text-foreground mb-1">
                    Quote Preparation
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    Our team is preparing a detailed quote based on your parcel requirements
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center mt-0.5">
                  <Mail className="w-4 h-4 text-muted-foreground" />
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-sm text-foreground mb-1">
                    You'll Be Notified
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    We'll notify you as soon as your quote is ready for review
                  </p>
                </div>
              </div>
            </div>

            {/* Expected Timeline */}
            <div className="w-full p-4 bg-muted/50 rounded-lg">
              <p className="text-xs text-muted-foreground text-center">
                <span className="font-medium text-foreground">Expected timeframe:</span> Most quotes are provided within 2 hours. Thank you for your patience.
              </p>
            </div>
          </div>
        </Card>
      )}
    </div>;
};
export default EmptyQuotesState;